import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-md-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "Guiide DB Transfer Panel", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" We would expect (as a guideline) the most competitive costs available for transfer advice to range between "),
  /*#__PURE__*/_createElementVNode("strong", { class: "text-nowrap" }, "1-2%"),
  /*#__PURE__*/_createTextVNode(" of your transfer value. ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " However advice on any transfer under £150,000 will be subject to a minimum of £3,000 as there is a very limited number of advisors who provide advice below this level. Although you will always see at least one adviser below. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "Guiide DB General Advisor Panel", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The costs of advice will depend on exactly the type of advice required. General retirement advice on selecting a provider, suitable investments and building a plan for retirement may be around "),
  /*#__PURE__*/_createElementVNode("strong", { class: "text-nowrap" }, "1-2%"),
  /*#__PURE__*/_createTextVNode(" of the value of the assets advised on, with a minimum cost of around "),
  /*#__PURE__*/_createElementVNode("strong", null, "£3,000.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " It is very difficult to obtain advice if your total assets (excluding your defined benefit pension assets) are below £100,000. However, you will always see at least one adviser below. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 offset-md-1 pt-4" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-info rounded-0",
    role: "alert"
  }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, " We recommend that if the cost of advice is an important factor, you request pricing details from each adviser shown. ")
    ])
  ])
], -1)
const _hoisted_10 = { class: "container-fluid p-5 bg-light border" }
const _hoisted_11 = { class: "advisor" }
const _hoisted_12 = { class: "row g-5" }
const _hoisted_13 = { class: "card border-0 shadow" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "card-footer bg-white" }
const _hoisted_17 = { class: "d-grid gap-2 d-md-block d-md-flex justify-content-md-between" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "does not", -1)
const _hoisted_22 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, "This will not be an additional cost to you. You will pay exactly the same fee if the adviser was willing to engage with you directly", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($props.showYesOutcome)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ], 64))
      ]),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.applicableAdvisors, (advisor) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-4 d-flex align-items-stretch",
              key: advisor.name
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: 'content/advisors/' + advisor.logo,
                    class: "mb-4 img-fluid mx-auto d-flex justify-content-center",
                    style: {"max-height":"75px"}
                  }, null, 8, _hoisted_15),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getAdvisorDescription(advisor), (advisorDesc, i) => {
                    return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(advisorDesc), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (advisor.moreDetailsAvailable())
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: $options.getMoreDetailsResource(advisor),
                          class: "btn btn-outline-secondary flex-md-fill",
                          target: "_blank"
                        }, "More Details", 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      href: advisor.contact,
                      class: "btn btn-warning flex-md-fill",
                      target: "_blank"
                    }, "Contact", 8, _hoisted_19)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        ($props.showYesOutcome)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
              _createTextVNode(" To be fully clear, Guiide "),
              _hoisted_21,
              _createTextVNode(" receive any referral payment from these advisers if you choose one from our site. Some advisers may have rights to license our technology so we may have other commercial relationships with some, but we do not receive any referral fees should you choose to take advice from any. ")
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_22, [
              _createTextVNode(" To be fully clear, Guiide will receive a referral payment from these advisers of 25% of the advice cost if you choose one from our site. "),
              _hoisted_23,
              _createTextVNode(". ")
            ]))
      ])
    ])
  ], 64))
}